module.exports = __webpack_public_path__ + "img/兴民钢圈.230d149c.png";